"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Credentials() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const partners = [{
    name: "Luxury Hotels",
    stars: "5*",
    location: "LA",
    logo: "UCC",
    logo_url: "https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?w=300&auto=format&fit=crop&q=80"
  }, {
    name: "Private Estates",
    stars: "EX",
    location: "MIA",
    logo: "\n",
    logo_url: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=300&auto=format&fit=crop&q=80"
  }, {
    name: "Corporate HQs",
    stars: "FT",
    location: "CHI",
    logo: "\n",
    logo_url: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=300&auto=format&fit=crop&q=80"
  }, {
    name: "Event Planners",
    stars: "PR",
    location: "LV",
    logo: "TUFF CROWD",
    logo_url: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=300&auto=format&fit=crop&q=80"
  }, {
    name: "Wealth Management",
    stars: "FIN",
    location: "SF",
    logo: "MGT GROUP\xA0",
    logo_url: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=300&auto=format&fit=crop&q=80"
  }, {
    name: "Concierge Services",
    stars: "CON",
    location: "LON",
    logo: "\n",
    logo_url: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=300&auto=format&fit=crop&q=80"
  }];
  const quotes = [{
    text: "unmatched punctuality",
    author: "J.S."
  }, {
    text: "the gold standard of transit",
    author: "A.M."
  }, {
    text: "discretion and elegance",
    author: "L.K."
  }, {
    text: "flawless execution",
    author: "R.D."
  }, {
    text: "the journey is the destination",
    author: "M.B."
  }, {
    text: "absolute professional service",
    author: "S.T."
  }];
  return <section data-section-id="2917" id="elite-credentials" className="bg-black text-white py-24 md:py-[140px] px-6 md:px-12 lg:px-16 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {}
          <div ref={headerRef} className={`lg:col-span-1 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#7A7A7A] mb-8">
              [§ 01] — Elite Credentials
            </div>
            <h2 className="font-default font-light text-[28px] md:text-[32px] leading-[1.15] text-white tracking-tight">
              Trusted by those
              <br />
              <span className="italic text-[#C0C0C0]">who demand</span>
              <br />
              perfection.
            </h2>

            <div className="mt-10 flex items-center gap-3">
              <div className="h-px w-12 bg-[#111111]" />
              <span className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#7A7A7A]">
                Service Standards
              </span>
            </div>

            <div className="mt-6 font-mono text-[11px] tracking-[0.15em] text-[#7A7A7A] space-y-2">
              <div className="flex justify-between max-w-[200px]">
                <span>YEARS ACTIVE</span>
                <span className="text-white">+20</span>
              </div>
              <div className="flex justify-between max-w-[200px]">
                <span>PARTNERS</span>
                <span className="text-white">50K+ &nbsp;</span>
              </div>
              <div className="flex justify-between max-w-[200px]">
                <span>LOCATIONS</span>
                <Link className="text-white underline cursor-pointer" href="https://book.mylimobiz.com/v4/bemax" newTab><span>1</span></Link>
              </div>
            </div>
          </div>

          {}
          <div ref={gridRef} className={`lg:col-span-2 transition-all duration-1000 ease-out delay-150 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-[#111111]">
              {partners.map((r, i) => <div key={i} data-index={i} className={`${r.starsClassName || ""} group relative aspect-[5/4] border-r border-b border-[#111111] flex items-center justify-center px-4 cursor-default transition-all duration-500`}>
                  {}
                  <div className="absolute inset-0 border border-transparent group-hover:border-[#C0C0C0] transition-colors duration-500 pointer-events-none" />

                  {}
                  <div className="text-center transition-all duration-500 group-hover:scale-105 flex items-center justify-center p-4">
                    {r.logo_url ? <img src={r.logo_url} alt={r.name} loading="lazy" className="max-h-16 w-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-500 opacity-70 group-hover:opacity-100" /> : <span className="font-default text-xs tracking-wider uppercase text-[#C0C0C0]">{r.name}</span>}
                  </div>

                  {}
                  <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between font-mono text-[9px] tracking-[0.18em] uppercase text-[#7A7A7A] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <span className="text-[#C0C0C0]">{r.stars}</span>
                    <span>· {r.location}</span>
                  </div>

                  {}
                  <div className="absolute top-3 left-3 font-mono text-[9px] tracking-[0.15em] text-[#7A7A7A] opacity-50">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {}
        
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>;
}